import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { formatDate, isAfter, isBefore, isSameDay, isThisYear } from 'date-fns';
import { format } from 'path';

@Pipe({
  name: 'eventDate',
  standalone: true,
})
export class EventDatePipe implements PipeTransform {
  datePipe = new DatePipe('nl-NL');

  transform(start: string, end?: string | null, alwaysShowStart: boolean = false, ...args: unknown[]): string {
    const startDate = new Date(start);
    const endDate = end ? new Date(end) : undefined;

    let dateString: Array<string | null> = [];

    if (this.multipleDays(startDate, endDate)) {
      if (!this.isOngoing(startDate, endDate) || alwaysShowStart) {
        dateString.push(this.datePipe.transform(startDate, 'd'));

        if (!this.sameMonth(startDate, endDate) || !isThisYear(startDate) || !isThisYear(endDate!)) {
          dateString.push(this.datePipe.transform(startDate, 'MMM'));
        }

        if (!isThisYear(startDate)) {
          dateString.push(this.datePipe.transform(startDate, 'yyyy'));
        }
      }

      let enddateformat = !this.isOngoing(startDate, endDate) ? 'd MMM' : 'd MMMM';

      if (this.isOngoing(startDate, endDate)) {
        enddateformat = `EEEE ${enddateformat}`;
      }

      dateString.push(`t/m ${this.datePipe.transform(endDate, enddateformat)}`);

      if (endDate && !isThisYear(endDate)) {
        dateString.push(this.datePipe.transform(endDate, 'yyyy'));
      }
    }

    if (!this.multipleDays(startDate, endDate)) {
      if (isThisYear(startDate)) {
        dateString.push(this.datePipe.transform(startDate, 'EEEE'));
      }
      dateString.push(this.datePipe.transform(startDate, 'd MMMM'));

      if (!isThisYear(startDate)) {
        dateString.push(this.datePipe.transform(startDate, 'yyyy'));
      }
    }

    // DEBUG
    //console.log(
    //  'INPUT DATE',
    //  formatDate(startDate, 'd MMMM yyyy'),
    //  '-',
    //  endDate ? formatDate(endDate, 'd MMMM yyyy') : null,
    //  'OUTPUT DATE',
    //  dateString.filter(Boolean).join(' ')
    //);
    return dateString.filter(Boolean).join(' ');
  }

  isOngoing(startDate: Date, endDate?: Date) {
    const afterStartDate = isAfter(new Date(), startDate);
    const beforeEndDate = endDate ? isBefore(new Date(), endDate!) : true;

    return afterStartDate && beforeEndDate;
  }

  multipleDays(startDate: Date, endDate?: Date) {
    return endDate ? !isSameDay(startDate, endDate!) : false;
  }

  thisYear(startDate: Date, endDate?: Date) {
    return isThisYear(startDate) && (endDate ? isThisYear(endDate!) : true);
  }

  isThisYear(date: string | Date) {
    return isThisYear(date);
  }

  sameMonth(startDate: Date, endDate?: Date) {
    return endDate ? new Date(startDate).getMonth() === new Date(endDate!).getMonth() : false;
  }
}
